<template>
  <div>
    <div class="loading" v-if="loading">
      Loading...
    </div>

    <div v-if="error" class="error">
      {{ error }}
    </div>

    <div class="filters-block filters-scenes">
      <div class="filters">
        <h3 class="filters-block__title">Search</h3>
      </div>
      <div class="filters-block__search">
        <div class="select-wrapper">
          <select class="query-control sort-type" name="filter__sort-type" v-model="searchType">
            <option value="all">All</option>
            <option value="name">Title</option>
            <option value="model">Model Name</option>
            <option value="studio">Studio Name</option>
            <option value="tag">Tag</option>
            <option value="date">Year</option>
          </select>
        </div>
        <input type="text" name="filter__search" class="query-control search-term" v-model="searchTerm" />
      </div>
      <div class="filters-block__filters">
        <div class="filters-block__sort">
          <div class="select-wrapper">
            <select class="query-control sort-type" name="filter__sort-type" v-model="sortType">
              <option value="_createdAt">Date Created</option>
              <option value="release">Date Released</option>
              <option value="name">Title</option>
              <option value="views">Views</option>
              <option value="year">Year</option>
            </select>
          </div>
          <div class="select-wrapper">
            <select class="query-control sort-order" name="filter__sort-order" v-model="sortOrder">
              <option value="asc">Ascending</option>
              <option value="desc">Descending</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <ul class="scene-list related-scenes">
      <li v-for="scene in scenes" class="list__item" :key="scene._id">
        <SceneTile :scene='scene'></SceneTile>
      </li>
    </ul>
  </div>
</template>

<script>
import sanity from "../sanity";
import imageUrlBuilder from "@sanity/image-url";
import SceneTile from '../components/SceneTile.vue';
import FiltersScenes from '../components/FiltersScenes.vue';

const imageBuilder = imageUrlBuilder(sanity);

export default {
  name: "Scenes",
  data() {
    return {
      loading: true,
      scenes: [],
      sortType: '_createdAt',
      sortOrder: 'asc',
      searchType: 'all',
      searchTerm: ''
    };
  },
  components: {
    SceneTile
  },
  created() {
    this.fetchScenes();
  },
  watch: {
    $route: "fetchScenes",
    sortType(newSortType, oldSortType) {
      if (newSortType != oldSortType) {
        this.sortType = newSortType;
        this.fetchScenes();
      }
    },
    sortOrder(newSortOrder, oldSortOrder) {
      if (newSortOrder != oldSortOrder) {
        this.sortOrder = newSortOrder;
        this.fetchScenes();
      }
    },
    searchType(newSearchType, oldSearchType) {
      if (newSearchType != oldSearchType) {
        this.searchType = newSearchType;
        this.fetchScenes();
      }
    },
    searchTerm(newSearchTerm, oldSearchTerm) {
      if (newSearchTerm != oldSearchTerm) {
        this.searchTerm = newSearchTerm;
        this.fetchScenes();
      }
    }
  },
  methods: {
    async fetchScenes() {
      let searchString = ``;
      let searchTerm = this.searchTerm;
      let searchType = this.searchType;

/*
            <option value="all">All</option>
            <option value="name">Title</option>
            <option value="model">Model Name</option>
            <option value="studio">Studio Name</option>
            <option value="tag">Tag</option>
*/

      if (searchTerm !== `` && searchType === 'all') {
        //searchString = `&& (name match "${searchTerm}*" || name match "${searchTerm}* || match "${searchTerm}*" in models || match "${searchTerm}*" in studios || match "${searchTerm}*" in tags)`;
      }
      if (searchTerm !== `` && searchType === 'name') {
        searchString = `&& name match "*${searchTerm}*"`;
      }
      if (searchTerm !== `` && searchType === 'model') {
        searchString = `&& "${searchTerm}" in models[].model.name`;
      }
      if (searchTerm !== `` && searchType === 'studio') {
        searchString = `&& "${searchTerm}" in studios[].studio.name`;
      }
      if (searchTerm !== `` && searchType === 'tag') {
        searchString = `&& "${searchTerm}" in tags[].tag.name`;
      }
      if (searchTerm !== `` && searchType === 'date') {
        searchString = `&& release match "*${searchTerm}*"`;
      }

      let query = `*[_type == "scene" ${searchString}] {
        _id,
        name,
        release,
        models,
        studios,
        thumbnail,
        screencaps,
        models[]->,
        studios[]->,
        favorite
      }[0...50] | order(${this.sortType} ${this.sortOrder})`;
      //console.log(query);
      this.error = this.post = null;
      this.loading = true;
      sanity.fetch(query).then(
        scenes => {
          this.loading = false;
          this.scenes = scenes;
          console.log(this.scenes);
        },
        error => {
          this.error = error;
        }
      );

      /*
      try {
        const res = await fetch('https://yesno.wtf/api')
        this.answer = (await res.json()).answer
      } catch (error) {
        this.answer = 'Error! Could not reach the API. ' + error
      }
      */
    },
    imageUrlFor(source) {
      return imageBuilder.image(source);
    }
  }
};
</script>

<style scoped>
.filters-block {
  display: flex;
  justify-content: space-between;
  background-color: var(--color-mono-4);
  padding: 18px 36px;
}
.filters-block__title {
  font-size: 1rem;
  font-weight: 400;
  margin: 0;
}
.filters-block__filters {
display: flex;
}
.filters-block__search {
  display: flex;
  width: 100%;
  flex-grow: 1;
}
.filters-block__sort {
  display: flex;
}
.search-term {
  width: 100%;
  max-width: 400px;
  background-color: var(--color-mono-4);
  border: solid 1px var(--color-mono-2);
  color: var(--color-mono-0);
  padding: 6px 24px 6px 12px;
  margin-left: 16px;
  border-radius: 16px;
  transition: background-color 0.35s ease-in-out;
}
.search-term:hover {
  background-color: var(--color-mono-3);
}
.filters-block select {
  appearance: none;
  position: relative;
  background-color: var(--color-mono-3);
  border-color: var(--color-mono-2);
  color: var(--color-mono-0);
  padding: 6px 24px 6px 12px;
  margin-left: 16px;
  border-radius: 16px;
}
.select-wrapper {
  position: relative;
}
.filters-block .select-wrapper:after {
  content: '';
    display: block;
    position: absolute;
    width: 0;
    height: 0;
    top: 55%;
    right: 12px;
    transform: translateY(-50%);
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 3px solid var(--color-mono-0);
}
</style>
